<template>
  <div class="main_wrapper">
    <div class="inner_top_header">
      <div class="tab_items">
        <p @click="$emit('changeTab', 1)">Movies</p>
        <p class="active" @click="$emit('changeTab', 2)">Series</p>
      </div>
      <div class="search" v-if="!showSeasons">
        <input type="text" v-model="search" placeholder="Search">
        <span>
          <b-icon icon="magnify" type="red"></b-icon>
        </span>
      </div>
    </div>
    <div v-if="allData.length > 0 && !loading && !showSeasons">
      <div class="wrapper_body" :class="{ activeSide: $store.state.sidebar }" v-if="dataComp.length > 0">
        <dataCard :seriesCard="true" @deleteMedia="deleteSerie(data.id)" @dataClick="viewDetails(data)"
          @edit="editSerie(data)" v-for="(data, index) in dataComp" :key="index" :dataObj='data' />
      </div>
      <p class="noFound" v-else>No Data Found Matching Your Search...</p>
    </div>
    <div v-if="allData.length == 0 && loading && !showSeasons">
      <widgetNotfound v-if="loading" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
      <widgetNotfound v-else title="No Data Found" subtitle="No records available at the moment. Add New">
      </widgetNotfound>
    </div>

    <div class="series_data" v-if="showSeasons" :class="{ activeSide: $store.state.sidebar }">
      <div class="series_data_header">
        <div class="action">
          <b-button @click="seasonsData = null; selectedSeries = null; showSeasons = false"
            type="is-black">BACK</b-button>
          <p>{{ selectedSeries.name }}</p>
        </div>
        <b-button type="is-primary" @click="toggleSeasonModal = true">ADD NEW SEASON</b-button>
      </div>
      <div class="series_data_split">
        <div class="seasons_data" v-if="!loadingSeasons && seasonsData.length > 0">
          <b-collapse class="card" animation="slide" v-for="(seaon, index) of seasonsData" :key="index"
            :open="isOpen == index" @open="isOpen = index" :aria-id="'contentIdForA11y5-' + index">
            <template #trigger="props">
              <div class="card-header" role="button" :aria-expanded="props.open">
                <p class="card-header-title">
                  Season {{ seaon.season_number }}
                </p>
                <div class="playlist-action">
                  <b-dropdown aria-role="list" class="is-pulled-right" position="is-bottom-left">
                    <template #trigger>
                      <b-icon icon="dots-vertical" type="is-white"></b-icon>
                    </template>
                    <b-dropdown-item @click="editSeason(seaon)" aria-role="listitem">Update</b-dropdown-item>
                    <b-dropdown-item @click="deleteSeason(seaon.id, seaon.series_id)"
                      aria-role="listitem">Delete</b-dropdown-item>
                  </b-dropdown>
                </div>
                <a class="card-header-icon">
                  <b-icon :icon="props.open ? 'menu-down' : 'menu-up'" :type="props.open ? 'is-primary' : 'is-dark'">
                  </b-icon>
                </a>
              </div>
            </template>
            <div class="card-content">
              <center v-if="seaon.episodes.length == 0">
                <p style="margin-bottom: 10px;">No Episodes, Add One</p>
              </center>
              <div class="content" v-else>
                <p @click="selectedEpisode = episode" v-for="(episode, index) in seaon.episodes" :key="index">{{
                  episode.episode_number }}</p>
              </div>
              <div class="card-content-actions">
                <b-button type="is-primary" @click="addNewEpisode(seaon)">ADD NEW EPISODE</b-button>
              </div>
            </div>
          </b-collapse>
        </div>
        <div class="seasons_data" v-else>
          <widgetNotfound v-if="loadingSeasons" title="Please Wait..." subtitle="Loading Data..."></widgetNotfound>
          <widgetNotfound v-else title="No Data Found" subtitle="No Seasons available at the moment. Add New">
          </widgetNotfound>
        </div>
        <div class="episode_data" :class="{ visibleAside: selectedEpisode }" v-if="selectedEpisode">
          <b-button type="is-primary" class="backButton" @click="selectedEpisode = null">BACK</b-button>
          <div class="episode_cover">
            <img v-if="selectedEpisode.cover"
              :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + selectedEpisode.cover" alt="Cover Image">
            <b-skeleton v-else id="img-skeleton"></b-skeleton>
            <div class="media" @click="toggleMedia">
              <b-icon icon="play"></b-icon>
            </div>
            <!-- <span class="indicator">Published</span> -->
          </div>
          <div class="action-buttons">
            <b-button type="is-primary" @click="toggleSeasonEpModal = true; editSeasonEpData = selectedEpisode">EDIT
              EPISODE</b-button>
            <b-button type="is-danger" @click="deleteEpisode(selectedEpisode.id, selectedEpisode.series_id)">DELETE
              EPISODE</b-button>
          </div>
          <div class="episode_mini_data">
            <div class="episode_mini_data_detail">
              <h1>{{ selectedSeries.title }}</h1>
              <div class="episode_mini_data_detail_series">
                <p>Episode {{ selectedEpisode.episode_number }} - {{ selectedEpisode.duration ?
                  toHHMMSS(selectedEpisode.duration) : '--' }}</p>
              </div>
            </div>
            <span>TV Series</span>
          </div>
          <div class="episode_main_data">

            <p>Lagging Image</p><br>
            <div class="episode_cover">
              <img v-if="selectedEpisode.lagging_image"
                :src="$store.state.ASSETS_BASE_URL + 'assets/uploaded/' + selectedEpisode.lagging_image"
                alt="Cover Image">
              <b-skeleton v-else id="img-skeleton"></b-skeleton>
            </div>
            <br>

            <p>Intro Start Time: {{ selectedEpisode.intro_start_time ? toHHMMSS(selectedEpisode.intro_start_time) : '--'
              }}</p>
            <p>Intro End Time: {{ selectedEpisode.intro_end_time ? toHHMMSS(selectedEpisode.intro_end_time) : '--' }}
            </p>
            <p>Episode End Time: {{ selectedEpisode.movie_end_time ? toHHMMSS(selectedEpisode.movie_end_time) : '--' }}
            </p>
          </div>
        </div>
        <div class="episode_data" v-else>
          <widgetNotfound title="No Episode Data" subtitle="Please Click on an episode to view data"></widgetNotfound>
        </div>
      </div>
    </div>

    <addNewSeason v-if="toggleSeasonModal || editSeasonData"
      :nextSeasonNumber="seasonsData[0] ? seasonsData[0].season_number + 1 : 0"
      :serieId="selectedSeries ? selectedSeries.id : 0" @closeModal="toggleSeasonModal = false; editSeasonData = null"
      @refresh="getSerieSeasons(selectedSeries.id)" :dataObj="editSeasonData" />
    <addNewSeasonEp v-if="toggleSeasonEpModal" @refresh="getSerieSeasons(selectedSeries.id)"
      :nextEpData="addEpisodeOnSeason"
      @closeModal="toggleSeasonEpModal = false; editSeasonEpData = null; addEpisodeOnSeason = null"
      :dataObj="editSeasonEpData" />
    <addNewSerieVue v-if="showModal || selected_data" @closeModal="$emit('closeModal'); selected_data = null"
      @refresh="getAllSeries()" :dataObj="selected_data" />


    <!-- ClapprPlayer -->
    <b-modal v-model="show_player" :width="800">
      <div style="height: 500px" v-if="selectedEpisode">
        <ClapprPlayer :src="`${$store.state.ASSETS_VIDEO_BASE_URL}${selectedEpisode.videoPath}`" type="hls">
        </ClapprPlayer>
      </div>
    </b-modal>

  </div>
</template>

<script>
import dataCard from '../components/dataCard.vue';
import addNewSeason from '../modals/addNewSeason.vue';
import addNewSeasonEp from '../modals/addNewSeasonEp.vue';
import addNewSerieVue from '../modals/addNewSerie.vue';
export default {
  props: {
    showModal: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      isOpen: 0,
      show_player: false,
      isPlaying: false,
      search: '',
      selected_data: null,
      toggleSeasonModal: false,
      toggleSeasonEpModal: false,
      editSeasonData: null,
      editSeasonEpData: null,
      loading: false,
      seasonsData: [],
      loadingSeasons: false,
      showSeasons: false,
      selectedSeries: null,
      selectedEpisode: null,
      selected: {
        id: 1,
        seasons: 2,
        episodes: 13
      },
      allData: [],
      addEpisodeOnSeason: null
    }
  },
  components: { dataCard, addNewSeason, addNewSeasonEp, addNewSerieVue },
  mounted() {
    let vm = this;
    vm.getAllSeries();
  },
  methods: {
    toggleMedia() {
      let vm = this;
      vm.show_player = !vm.show_player
    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
    viewDetails(data) {
      let vm = this;
      vm.selectedSeries = data;
      vm.showSeasons = true;
      vm.getSerieSeasons(data.id);
    },
    getSerieSeasons(id) {
      let vm = this;
      vm.loadingSeasons = true;
      vm.selectedEpisode = null
      vm.$store.dispatch('GET_SERIES_SEASONS', { id: id })
        .then(res => {
          vm.seasonsData = res.data.return;
          vm.loadingSeasons = false
        })
        .catch(err => {
          vm.loadingSeasons = false
          console.log(err);
        })
    },
    editSeason(data) {
      let vm = this;
      vm.editSeasonData = data;
    },
    deleteSeason(id, serieId) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting Season',
        message: 'Are you sure you want to delete this Season?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_SERIES_SEASONS', { id: id })
            .then(res => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Serie Deleted Successfully',
              });
              vm.loadingSeasons = true;
              vm.getSerieSeasons(serieId);
            })
            .catch(err => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              console.log(err);
            })
        }
      })
    },
    getAllSeries() {
      let vm = this;
      vm.loading = true;
      vm.$store.dispatch('GET_SERIES')
        .then(res => {
          vm.loading = false;
          vm.allData = res.data.return;
        })
        .catch(err => {
          vm.loading = false;
          console.log(err);
        })
    },
    editSerie(data) {
      let vm = this;
      vm.selected_data = data;
    },
    deleteSerie(id) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting Serie',
        message: 'Are you sure you want to delete this Serie?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_SERIES', { id: id })
            .then(res => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Serie Deleted Successfully',
              });
              vm.loading = true;
              vm.getAllSeries();
            })
            .catch(err => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              console.log(err);
            })
        }
      })
    },
    deleteEpisode(id, serieId) {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: 'Deleting This Episode',
        message: 'Are you sure you want to delete this episode?',
        confirmText: 'Delete',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          vm.$store.dispatch('DELETE_SEASONS_EPISODES', { id: id })
            .then(res => {
              vm.$notify({
                group: "status",
                type: "success",
                title: "SUCCESS!!!",
                text: 'Episode Deleted Successfully',
              });
              vm.loadingSeasons = true;
              vm.getSerieSeasons(serieId);
            })
            .catch(err => {
              vm.$notify({
                group: "status",
                type: "error",
                title: "OOPS!!!",
                text: 'Something went wrong',
              });
              console.log(err);
            })
        }
      })
    },
    addNewEpisode(season) {
      let vm = this;
      vm.toggleSeasonEpModal = true;
      vm.addEpisodeOnSeason = {
        season_number: season.season_number,
        series_id: season.series_id,
        nextEpisode: season.episodes[0] ? season.episodes[0].episode_number + 1 : 1
      }
    },
  },
  computed: {
    dataComp() {
      let vm = this;
      return vm.allData.filter(data => data.title.toLowerCase().includes(vm.search.toLowerCase()))
    }
  }
}
</script>

<style lang="scss" scoped>
.main_wrapper {
  overflow: hidden;

  // overflow-y: auto;
  .inner_top_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    position: sticky;
    top: 0;
    background: var(--white, #FFF);
    z-index: 10;
    width: 100%;
    border-bottom: 1px solid #ddd;
    column-gap: 30px;
    overflow-x: auto;

    .tab_items {
      display: flex;
      column-gap: 20px;

      p {
        cursor: pointer;
        font-size: 18px;
        font-weight: 600;
        position: relative;

        &::before {
          position: absolute;
          width: 0%;
          transition: .5s;
          left: 0;
          bottom: -5px;
          content: '';
          height: 2px;
          border-radius: 5px;
          background: var(--wecodefy-secondary-color, #9fc953);
        }

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);

          &::before {
            width: 80%;
          }
        }
      }
    }

    .search {
      display: flex;
      align-items: center;
      position: relative;

      input {
        padding: 5px 10px;
        width: 300px;
        border-radius: 5px;
        border: none;
        background: #dbdbdb;
        background: #eeeeee;
        border: 1px solid #dbdbdb;
        outline: none;

        @media (max-width: 500px) {
          width: 250px;
        }

        @media (max-width: 433px) {
          width: 200px;
        }
      }

      span {
        position: absolute;
        right: 5px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  .wrapper_body {
    // height: calc(100% - 60px);
    height: calc(100vh - 190px);
    display: grid;
    padding: 20px;
    grid-template-columns: repeat(6, calc(100%/6.4));
    row-gap: 50px;
    overflow-y: auto;
    justify-content: space-between;

    @media (max-width: 1307px) {
      grid-template-columns: repeat(5, calc(100%/5.3));
    }

    @media (max-width: 1000px) {
      grid-template-columns: repeat(4, calc(100%/4.25));
    }

    @media (max-width: 768px) {
      grid-template-columns: repeat(3, calc(100%/3.15));
      row-gap: 30px;
    }

    @media (max-width: 600px) {
      grid-template-columns: repeat(2, calc(100%/2.05));
    }

    @media (max-width: 450px) {
      grid-template-columns: repeat(1, 1fr);
    }

    &.activeSide {
      grid-template-columns: repeat(5, calc(100%/5.3));

      @media (max-width: 1300px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 1100px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
      }

      @media (max-width: 966px) {
        grid-template-columns: repeat(4, calc(100%/4.25));
      }

      @media (max-width: 768px) {
        grid-template-columns: repeat(3, calc(100%/3.15));
        row-gap: 30px;
      }

      @media (max-width: 600px) {
        grid-template-columns: repeat(2, calc(100%/2.05));
      }

      @media (max-width: 450px) {
        grid-template-columns: repeat(1, 1fr);
      }
    }
  }

  .series_data {
    height: calc(100vh - 190px);
    overflow-y: auto;

    &.activeSide {
      @media (max-width: 1175px) {
        .seasons_data {
          padding-right: 20px;
        }

        .episode_data {
          padding-left: 20px;
        }
      }
    }

    .series_data_header {
      padding: 5px 20px;
      justify-content: space-between;
      display: flex;
      align-items: center;
      border-bottom: 1px solid rgba(0, 0, 0, 0.20);
      position: sticky;
      top: 0;
      background: white;
      z-index: 5;
      overflow-x: auto;
      column-gap: 30px;

      .action {
        display: flex;
        align-items: center;
        column-gap: 10px;

        p {
          white-space: nowrap;
        }
      }
    }

    .series_data_split {
      padding: 20px;
      overflow-y: auto;
      overflow-y: auto;
      display: grid;
      justify-content: space-between;
      grid-template-columns: 50% 50%;

      // position: relative;
      @media (max-width: 840px) {
        grid-template-columns: 60% 40%;
      }

      @media (max-width: 768px) {
        grid-template-columns: 100%;
      }
    }

    .seasons_data {
      padding-right: 80px;
      border-right: 1px solid rgba(0, 0, 0, 0.20);

      @media (max-width: 950px) {
        padding-right: 30px;
      }

      @media (max-width: 768px) {
        padding-right: 0;
        padding-bottom: 20px;
        border-right: 0;
        border-bottom: 1px solid rgba(0, 0, 0, 0.20);
      }

      .collapse.card {
        margin-bottom: 20px;

        .collapse-trigger {
          .card-header {
            background: #CFCFCF;
            transition: .5s;

            .playlist-action {
              display: flex;
              align-items: center;
            }

            &[aria-expanded='true'] {
              background: #454545;

              .card-header-title {
                color: var(--wecodefy-secondary-color, #9fc953);
              }
            }
          }
        }

        .card-content {
          padding: 15px;
          border-radius: 0;

          .content {
            display: grid;
            grid-template-columns: repeat(6, calc(100%/6.4));
            justify-content: space-between;
            row-gap: 10px;

            p {
              padding: 5px;
              border-radius: 5px;
              text-align: center;
              margin: 0;
              background: #454545;
              color: #B4B4B4;
              cursor: pointer;
            }
          }

          .card-content-actions {
            display: flex;
            justify-content: center;
            column-gap: 15px;
            flex-wrap: wrap;
            row-gap: 10px;

            @media (max-width: 441px) {
              flex-direction: column;
              row-gap: 5px;
            }

            button {
              display: flex;
              margin: 0;
            }
          }
        }
      }
    }

    .episode_data {
      padding-left: 50px;

      @media (max-width: 950px) {
        padding-left: 30px;
      }

      @media (max-width: 768px) {
        padding-left: 0;
        padding-top: 20px;
        position: absolute;
        top: 0;
        top: calc(190px);
        right: 0;
        padding: 15px;
        border-left: 1px solid rgba(0, 0, 0, 0.20);
        background: white;
        // min-height: 100vh;
        height: calc(100vh - 190px);
        overflow-y: auto;
        width: 400px;
        display: none;
        padding-bottom: 100px;
      }

      @media (max-width: 560px) {
        width: 300px;
      }

      @media (max-width: 360px) {
        width: 100%;
      }

      button.backButton {
        display: none;
        margin-bottom: 15px;

        @media (max-width: 800px) {
          display: block;
        }
      }

      &.visibleAside {
        display: block;
      }

      .action-buttons {
        display: flex;
        column-gap: 5px;
        flex-wrap: wrap;
        row-gap: 10px;
        margin-bottom: 10px;
      }

      .episode_cover {
        width: 100%;
        height: 350px;
        border-radius: 5px;
        overflow: hidden;
        position: relative;
        margin-bottom: 20px;

        .b-skeleton.is-animated {
          height: 100%;

          .b-skeleton-item.is-rounded {
            height: 100%;
          }
        }

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }

        .media {
          width: 50px;
          height: 50px;
          padding: 5px;
          display: flex;
          justify-content: center;
          align-items: center;
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          border-radius: 50%;
          cursor: pointer;
          box-shadow: 0 0 20px rgba(0, 0, 0, 0.344);
        }

        .indicator {
          position: absolute;
          top: 20px;
          right: 20px;
          background: #6EC492;
          padding: 6px 13px;
          font-size: 15px;
          border-radius: 3px;
          color: white;
        }
      }

      .episode_mini_data {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        .episode_mini_data_detail {
          h1 {
            font-size: 18px;
          }

          .episode_mini_data_detail_series {
            display: flex;
            column-gap: 15px;

            p {
              font-size: 15px;
            }
          }
        }

        span {
          padding: 3px 8px;
          border: 1px solid #4E4E4E;
          border-radius: 5px;
        }
      }

      .episode_main_data {
        h1.movie-name {
          font-size: 23px;
        }

        .rate {
          display: flex;
          column-gap: 15px;

          .rating {
            display: flex;
            align-items: center;
            column-gap: 5px;
          }
        }
      }

      .episode-details {
        margin-top: 20px;
        display: flex;
        flex-direction: column;
        row-gap: 5px;

        .episode-details-card {
          display: flex;

          h1 {
            font-weight: 600;
            margin-right: 10px;
          }

          .episode-details-card-info {
            display: flex;

            span {
              &:last-of-type {
                i {
                  display: none;
                }
              }
            }

            i {
              display: inline-flex;
              margin-right: 5px;
            }
          }
        }
      }
    }
  }

  .noFound {
    text-align: center;
    margin: 20px auto;
  }
}
</style>